import React from "react";
import { Link } from "react-router-dom";
import sellersMap from "../../../assets/new-home/sellers-map.png";
import buyersMap from "../../../assets/new-home/buyers-map.png";
import tickIcon from "../../../assets/new-home/tick.svg";
import AnimateFromBottom from "../../LandingPage/component/AnimateFromBottom";
import useLocale from "../../../components/Hooks/useLocale";
import { urlWithLocalization } from "../../../components/LocalizationUrl/UrlWithLocalization";
import language from "../../../helpers/language";

const Check = () => (
  <img
    src={tickIcon}
    alt=""
    aria-hidden="true"
    className="w-5 h-5 flex-shrink-0 mt-px"
  />
);

const FeatureItem = ({ label }) => (
  <li className="flex items-start gap-2 w-full text-sm font-medium text-gray-900 leading-snug text-left">
    <Check />
    <span className="flex-1 text-left">{label}</span>
  </li>
);

const IllustrationCard = ({ image, title }) => (
  <div className="bg-white px-4 pt-4 pb-0 border-b border-gray-100">
    <img
      src={image}
      alt={title}
      className="w-full h-auto object-contain rounded-md"
    />
  </div>
);

const SellersAndBuyers = () => {
  const localeLocalization = useLocale();
  const [lang] = React.useState(language.getLang());

  const sellerFeatures = lang?.sellerFeatures ;
  const buyerFeatures = lang?.buyerFeatures;
  

  return (
    <div className="bg-white md:py-16 py-10">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-10">

        {/* SELLERS â€” green */}
        <AnimateFromBottom delay={0.2}>
          <div className="rounded-xl border border-gray-200 overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow flex flex-col h-full">
            <IllustrationCard image={sellersMap} title={lang?.alysei_for_producers} />
            <div className="px-7 py-6 flex flex-col flex-1">
              <h3 className="text-base font-bold text-gray-900 mb-2">{lang?.alysei_for_producers}</h3>
              <p className="text-xs text-gray-500 leading-relaxed mb-6">
                {lang?.alysei_for_seller_description}
              </p>

              <ul className="grid grid-cols-2 gap-x-8 gap-y-4 mb-7 flex-1 justify-items-start">
                {sellerFeatures.map((f, i) => <FeatureItem key={i} label={f} />)}
              </ul>

              <Link
                to={urlWithLocalization(localeLocalization, "/seller")}
                className="learn-more-link inline-flex w-full sm:w-56 items-center justify-between bg-green-500 hover:text-white hover:bg-green-600 text-white text-sm font-semibold px-6 py-3 rounded-md transition-colors"
              >
                <span>{lang?.Learn_More}</span>
                <span className="learn-more-link__icon w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                  <i className="fa fa-arrow-right text-green-500 text-xs" />
                </span>
              </Link>
            </div>
          </div>
        </AnimateFromBottom>

        {/* BUYERS â€” blue */}
        <AnimateFromBottom delay={0.3}>
          <div className="rounded-xl border border-gray-200 overflow-hidden bg-white shadow-sm hover:shadow-md transition-shadow flex flex-col h-full">
            <IllustrationCard image={buyersMap} title={lang?.alysei_for_buyer} />
            <div className="px-7 py-6 flex flex-col flex-1">
              <h3 className="text-base font-bold text-gray-900 mb-2">{lang?.alysei_for_buyer}</h3>
              <p className="text-xs text-gray-500 leading-relaxed mb-6">
                {lang?.alysei_for_buyer_description}
              </p>

              <ul className="grid grid-cols-2 gap-x-8 gap-y-4 mb-7 flex-1 justify-items-start">
                {buyerFeatures.map((f, i) => <FeatureItem key={i} label={f} />)}
              </ul>

              <Link
                to={urlWithLocalization(localeLocalization, "/buyer")}
                className="learn-more-link hover:text-white inline-flex gap-6 w-full sm:w-56 items-center justify-between bg-royal hover:opacity-90 text-white text-sm font-semibold px-6 py-3 rounded-md transition-opacity"
              >
                <span>{lang?.Learn_More}</span>
                <span className="learn-more-link__icon w-7 h-7 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                  <i className="fa fa-arrow-right text-royal text-xs" />
                </span>
              </Link>
            </div>
          </div>
        </AnimateFromBottom>

        </div>
      </div>
    </div>
  );
};

export default SellersAndBuyers;
